<template>
  <footer class="text-muted py-5">
    <div class="container">
      <p class="float-end mb-1">
        <a href="#">بازگشت به بالا</a>
      </p>
      <p class="mb-1">
        تهران - خیابان جمهوری، بین جمالزاده و سلیمانیه، پلاک 1370، عکاسی تصویر
      </p>
      <p class="mb-0">
        66926480 - 66945024 - 66905372 - 09121443023 - کامران بانکی
      </p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
</style>